
import noUiSlider from 'nouislider';
const wNumb = require("wNumb");
import 'nouislider/dist/nouislider.css';


export default function sliderClassInit(coreHandlerInstance, paramInstance) {
  const unionClassName = ".js__data-box";
  const targetClassName = ".js__range-item";
  const coreHandler = coreHandlerInstance;
  const outputArea = document.getElementById("js__select-list");
  const outputAreaBody = document.getElementById("js__select-list-body");

  const paramHandler = paramInstance;

  class SliderClass {
    static selectList = [];
    static instanceList = [];

    static init = () => {
      SliderClass.instanceList = [...document.querySelectorAll(targetClassName)].map(v => {
        return new SliderClass(v);
      });
    }
    static allReset = () => {
      [...SliderClass.instanceList].forEach(v => {
        v.resetBtnHidden();
        v.resetEvent();
      });
    }
    static rebuild = (json) => {
      let resultRangeList = Object.entries(json.range).filter(v => ((v[1].PropertyType === "NumericRange" || v[1].PropertyType === "Numeric") &&  ( v[1].Min !== null && v[1].Max !== null )));

      [...SliderClass.instanceList].forEach(ele => {

        let propId = ele.data.PropertyId;
        let findItem = resultRangeList.find(v => v["1"].PropertyId === Number(propId));
        if (findItem) {
          ele.data.Val1 = findItem["1"].Min;
          ele.data.Val2 = findItem["1"].Max;
        }

      });

      [...SliderClass.instanceList].forEach(ele => {
        if (ele.select == false) {

          if(ele.data.Val1 !== null && ele.data.Val2 !== null){

            ele.slider.updateOptions({
              start:[parseFloat(ele.data.Val1), parseFloat(ele.data.Val2)],
              range: {
                'min': parseFloat(ele.data.Val1),
                'max': parseFloat(ele.data.Val2)
              }
            },
              true
            );
          }
        }
      });

    }

    static paramLoad = (sliderList) => {

      let loadList = [];
      for (var prop in sliderList) {
        let filterList = SliderClass.instanceList.filter(v => {
          let instanceItem = v.data;
          let paramItem = sliderList[prop];
          return (paramItem.PropertyId == instanceItem.PropertyId);
        });
        if (filterList) {
          loadList = loadList.concat(filterList);
        }
      }
      if (loadList.length > 0) {

        loadList.forEach(v => {
          let propData = sliderList.filter(v2 => v2.PropertyId == v.data.PropertyId);
          if (propData["0"].hasOwnProperty('Val1') && propData["0"].hasOwnProperty('Val2')) {

            v.data.Val1 = propData["0"].Val1;
            v.data.Val2 = propData["0"].Val2;
            v.select = true;
            v.resetBtnShow();
            v.addFilterEvent();
            v.slider.set([v.data.Val1, v.data.Val2]);
          }

        });
      }
    }

    constructor(selector) {
      this.instanceType = "SliderClass";
      this.ele = selector;
      this.union = this.ele.closest(unionClassName);
      this.target = selector.querySelector('.js__noui-slider');
      this.title = this.ele.parentNode.querySelector('.js__range-title').innerText;
      this.name = this.target.getAttribute('data-name');
      this.session = document.getElementById('js__main').getAttribute('data-session');
      this.resetBtn = this.ele.parentNode.querySelector('.js__reset-btn');
      this.resethandler = this.clearEvent.bind(this);
      this.resetBtn.addEventListener('click', this.resethandler);
      this.min = Number(this.target.getAttribute('data-min'));
      this.max = Number(this.target.getAttribute('data-max'));
      this.start = Number(this.target.getAttribute('data-start'));
      this.end = Number(this.target.getAttribute('data-end'));
      this.decimal = Number(this.ele.getAttribute("data-decimal"));
      this.stepArea = this.ele.querySelector('.js__slider-step');
      this.select = false;
      this.data = {
        "Type": "numeric",
        "PropertyId": Number(this.ele.getAttribute('data-property-id')) || null,
        "UnitId": Number(this.ele.getAttribute('data-unit-id')) || null,
        "Val1": this.start,
        "Val2": this.end
      };
      this.slider = noUiSlider.create(
        this.target, {
        start: [this.start, this.end],
        connect: true,
        range: {
          "min": this.min,
          "max": this.max
        },
        format: wNumb({
          decimals: this.decimal,
          thousand: ',',
        }),
      }, true);
      this.stepEvent = (() => {
        return this.slider.on('update', (values, handle) => {
          this.stepArea.innerHTML = values.join(' - ');
        });
      })();
      // this.gaEvent = () => {
      //   if (typeof ga === "function") {
      //     let gaValue = this.data.Val1 + "-" + this.data.Val2;
      //     let gaEvent = [this.session, "物性値", this.name, gaValue].join(":");
      //     ga('send', 'event', 'グレード検索', 'クリック', gaEvent, 1);
      //   }
      // };
      this.dataLayerEvent = () => {
      
        const value = this.data.Val1 + "-" + this.data.Val2;
        const EventValue =  [this.session, "物性値", this.name, value].join(":");

        dataLayer.push({
          'event': 'gradeSearchPageSliderUpdate',
          'value': value,
          'gaEvent': EventValue,
          'sessionId': this.session,
          'propertyName': this.name
        });
      }
      this.sendEvent = (() => {
        return this.slider.on('change', (values, handle) => {
          let type;
          this.select = true;
          this.data.Val1 = values[0];
          this.data.Val2 = values[1];
          this.target.setAttribute('data-start', values[0]);
          this.target.setAttribute('data-end', values[1]);

          if (this.min == this.data.Val1 && this.max == this.data.Val2) {
            this.removeLabel();
            this.resetBtnHidden();
            let clearTarget = [...SliderClass.instanceList].filter(v => {
              return [...SliderClass.selectList].some(v2 => {
                return v.data.PropertyId != v2.data.PropertyId;
              });
            });
            if (clearTarget.length < 1) {
              clearTarget = SliderClass.instanceList;
            }
            paramHandler.remove(this);

          } else {
            this.resetBtnShow();
            this.addSelectList();
            // this.gaEvent();
            this.dataLayerEvent();
            paramHandler.add(this);
          }
          
          coreHandler.setRecentEvent(this);
          coreHandler.sliderEvent(this.data, [this.min, this.max]);

        });
      })();

    }


    removeLabel = (option) => {
      SliderClass.selectList = [...SliderClass.selectList].filter(v => {
        return this.data.PropertyId != v.data.PropertyId;
      });
      let labelList = outputAreaBody.querySelectorAll(".js__select-label");
      let removeItemSearch = [...labelList].filter(v => {
        return Number(v.getAttribute("data-property-id")) === this.data.PropertyId;
      });

      if (removeItemSearch.length !== 0) {
        outputAreaBody.removeChild(removeItemSearch[0]);
      }

      labelList = outputArea.querySelectorAll(".js__select-label");

      if (labelList.length < 1) {
        outputArea.style.display = "none";
      }

    }
    addFilterEvent = () => {
      this.addSelectList();
      coreHandler.setFilter(this.data);
    }
    addSelectList = () => {
      if (typeof SliderClass.selectList !== "undefined") {
        let existCheck = SliderClass.selectList.some(v => {
          return v.data.PropertyId === this.data.PropertyId;
        });

        if (!existCheck) {
          SliderClass.selectList.push(this);
        }
      }

      let labelText = this.title + ":" + this.data.Val1 + "-" + this.data.Val2;
      let labelList = outputAreaBody.querySelectorAll(".js__select-label");

      let selectLabel = [...labelList].filter(v => {
        return Number(v.getAttribute("data-property-id")) === this.data.PropertyId;
      });
      if (selectLabel.length !== 0) {
        selectLabel[0].lastElementChild.innerText = labelText;
      } else {

        const newButton = document.createElement("button");
        newButton.className = "p-label js__select-label";
        newButton.setAttribute('data-property-id', this.data.PropertyId);
        newButton.innerHTML = "<span class=\"material-icons-outlined p-material-icon\">close</span> <span>" + labelText + "</span>";
        outputAreaBody.appendChild(newButton);
        outputArea.style.display = "flex";

        newButton.addEventListener("click", () => {
          this.resetEvent(true);
          this.removeLabel();
          this.resetBtnHidden();
          let clearTarget = [...SliderClass.instanceList].filter(v => {
            return [...SliderClass.selectList].some(v2 => {
              return v.data.PropertyId != v2.data.PropertyId;
            });
          });
          if (clearTarget.length < 1) {
            clearTarget = SliderClass.instanceList;
          }
          paramHandler.remove(this);
          this.data.Val1 = this.min;
          this.data.Val2 = this.max;
          
          coreHandler.setRecentEvent(this);
          coreHandler.sliderEvent(this.data, [this.min, this.max]);
        }, true);
      }

    }

    resetEvent = (movingFlag = null) => {
      this.select = false;
      this.data.Val1 = this.min;
      this.data.Val2 = this.max;
      if (movingFlag == true) {
        return this.slider.set([this.min, this.max]);
      }
    };


    clearEvent = () => {

      this.resetEvent();
      this.removeLabel();
      this.resetBtnHidden();
      let clearTarget = [...SliderClass.instanceList].filter(v => {
        return [...SliderClass.selectList].some(v2 => {
          return v.data.PropertyId != v2.data.PropertyId;
        });
      });
      if (clearTarget.length < 1) {
        clearTarget = SliderClass.instanceList;
      }
      paramHandler.remove(this);
      
      coreHandler.setRecentEvent(this);
      coreHandler.sliderEvent(this.data, [this.min, this.max]);

    }
    resetBtnShow = () => {
      this.resetBtn.style.display = "block";
    }
    resetBtnHidden = () => {
      this.resetBtn.style.display = "none";
    }


  }
  SliderClass.init();
  return SliderClass;
}